var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path0, _path1, _path10;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgUpdateContractInformationOverview(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 48,
    height: 52,
    viewBox: "0 0 48 52",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M24.776 48.7636H3.75882C2.24147 48.7636 1 47.5222 1 46.0048V9.04495C1 7.5276 2.24147 6.28613 3.75882 6.28613H12.1168",
    stroke: "#257239",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M26.6426 6.28613H35.0006C36.5179 6.28613 37.7594 7.5276 37.7594 9.04495V31.3245",
    stroke: "#257239",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M21.7726 44.7824H6.54892C5.91774 44.7824 5.39941 44.2661 5.39941 43.6328V10.7276C5.39941 10.0964 5.91565 9.57812 6.54892 9.57812H10.4698",
    stroke: "#257239",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M27.9111 9.57812H32.2082C32.8394 9.57812 33.3577 10.0944 33.3577 10.7276V35.7911",
    stroke: "#257239",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M23.4258 5.13614H22.6107C22.6734 4.87907 22.711 4.61155 22.711 4.33358C22.711 2.49227 21.2187 1 19.3774 1C17.5361 1 16.0439 2.49227 16.0439 4.33358C16.0439 4.61155 16.0815 4.87907 16.1442 5.13614H15.3291C12.9276 5.13614 10.9609 7.10076 10.9609 9.50428V11.9705H27.7877V9.50428C27.7877 7.10285 25.823 5.13614 23.4195 5.13614H23.4258Z",
    stroke: "#257239",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M17.2031 21.0361H28.8926",
    stroke: "#257239",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M9.94043 20.0017L11.8361 21.7468L14.6534 18.6641",
    stroke: "#257239",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M17.2041 27.3623H28.8936",
    stroke: "#257239",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M9.94141 26.3278L11.8371 28.073L14.6544 24.9902",
    stroke: "#257239",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path0 || (_path0 = /*#__PURE__*/React.createElement("path", {
    d: "M17.2041 33.6377H28.8936",
    stroke: "#257239",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path1 || (_path1 = /*#__PURE__*/React.createElement("path", {
    d: "M9.94141 32.6032L11.8371 34.3484L14.6544 31.2656",
    stroke: "#257239",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M46.2827 35.2843L44.0066 33.0082C43.6012 32.6028 42.9428 32.609 42.5457 33.0208L33.2828 42.6244C32.8857 43.0361 32.2273 43.0424 31.8219 42.6369L29.1989 40.014C28.7997 39.6148 28.1518 39.6148 27.7505 40.014L25.4703 42.2942C25.0711 42.6934 25.0711 43.3413 25.4703 43.7426L31.8239 50.0983L31.8469 50.0753C32.2503 50.4787 32.9066 50.4745 33.3037 50.0648L46.2889 36.7243C46.6798 36.323 46.6756 35.6834 46.2785 35.2863L46.2827 35.2843Z",
    stroke: "#257239",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUpdateContractInformationOverview);
export default __webpack_public_path__ + "static/media/update-contract-information-overview.29709b7f6a60e33485413d468c032985.svg";
export { ForwardRef as ReactComponent };